<template>
	<sideNav :page-title="pageTitle"></sideNav>
	<div v-show="showFlag">
		<div class="ld-panel-title">
			<router-link to="/verify" class="back-btn"><span></span>个人认证</router-link>
		</div>
		<div class="ld-panel-main">
			<el-steps :active="0" finish-status="success" simple>
			    <el-step title="填写认证资料" />
			    <el-step title="认证信息校验" />
			</el-steps>
			<el-form :rules="rules" ref="ruleFormRef" :model="groupForm" inline-message :label-width="formLabelWidth" class="form-main">
				<el-form-item label="真实姓名" prop="truename">
					<el-input v-model="groupForm.truename" autocomplete="off" />
				</el-form-item>
				<p class="form-tip" style="margin-left: 160px;">请填写您本人的真实姓名，否则无法通过，可能产生额外认证费用</p>
				<el-form-item label="身份证号" prop="id_card">
					<el-input v-model="groupForm.id_card" autocomplete="off" />
				</el-form-item>
				<p class="form-tip" style="margin-left: 160px;">请填写您本人的真实身份证号，否则无法通过，可能产生额外认证费用</p>
				<el-form-item>
					<el-button @click="btnBack">上一步</el-button>
					<el-button type="primary" @click="submitForm(ruleFormRef)">下一步</el-button>
				</el-form-item>
			</el-form>
			<div class="foot-warn" style="margin-top: 60px;">
				<h4 class="title">温馨提示：</h4>
				<div class="content">
					<p>1. 请确保姓名、身份证号码完全正确，请勿使用他人身份信息进行认证，以防认证失败</p>
					<p>2. 1个身份信息仅支持实名认证1个蓝队云账号，如您的信息被他人盗用，可提交工单进行申诉</p>
					<p>3. 请勿使用虚假信息认证，否则蓝队云有权注销您的实名认证信息</p>
					<p>4. 蓝队云平台会加密保存您的认证资料，绝不会泄露用户隐私，请放心认证</p>
					<p>5. 所填写资料仅用于实名认证，不会开通其他任何附加服务</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { authInfo,personsave } from '@/api/auth';
	import sideNav from '../../components/sideNav.vue';
	import { ElMessage } from 'element-plus';
	
	const router = useRouter();
	const pageTitle = 'account';
	const showFlag = ref(false);
	const formLabelWidth = ref('160px');
	const ruleFormRef = ref(null);
	const groupForm = ref({truename:'',id_card:''});
	const rules = reactive({
		truename: [
			{ required: true, message: '请填写真实姓名', trigger: 'blur' }
		],
		id_card: [
			{ required: true, message: '请填写身份证号', trigger: 'blur' }
		]
	});
	
	const generData = () => {
		authInfo().then((res) => {
			if(res.code === 200){
				if (res.data.authStatus == '1') {
					router.push({ path: '/verify/success' })
				}else{
					groupForm.value.truename = res.data.trueName;
					groupForm.value.id_card = res.data.IDCard;
					showFlag.value = true;
				}
			}
		})
	};
	const submitForm = () => {
	  if (!ruleFormRef.value) return;
	  ruleFormRef.value.validate((valid) => {
	    if (valid) {
			const param = groupForm.value;
			personsave(param).then((res) => {
				if(res.code === 200){
					ElMessage({
						offset:70,
						message: res.msg,
						type: 'success'
					})
					router.push({ path: '/verify/persontab' })
				}
			})
	    } else {
	      return false;
	    }
	  });
	};
	const btnBack = () => {
		router.push({ path: '/verify' })
	};
	
	onMounted(() => {
		generData()
	})
	
</script>

<style scoped>
	
</style>